<div class="flex flex-col items-center text-center max-w-[30rem] h-[12.1875rem] py-6 mt-12">
  <img src="/assets/images/maslulan_empty_state.svg" alt="">

  <!-- Show searching message when coming from a shared link -->
  @if (isSearchingFromSharedLink) {
    <span class="text-base">{{searchingForLinesText}}</span>
  } @else {
    <span class="text-base">{{noResultText}}</span>
    <span class="text-base">{{forText}} {{noResultsForWhatText}}</span>
  }

  <!-- Normal no results message -->
</div>
